export default __webpack_public_path__ + "../images/category-catalog-4.png";